module.exports = __webpack_public_path__ + "assets/nitropack.9bd7f519.svg";